import { Button, ButtonSize, ButtonVariant } from 'smoothie';

interface CreateEditButtonProps {
    text?: string;
    disabled?: boolean;
    onPress: () => void;
}

const CreateEditButton = ({
    text = 'Next',
    disabled,
    onPress,
}: CreateEditButtonProps) => {
    return (
        <Button
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.LARGE}
            text={text}
            onPress={onPress}
            disabled={disabled}
        />
    );
};

export default CreateEditButton;
